import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InsuranceDTO } from '../../../api/useInsuranceQuery';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Label } from '../../../../../CommonComponents/OPL/Label/Label';
import { Radio } from '../../../../../CommonComponents/OPL/Radio/Radio';

interface Props {
  data: InsuranceDTO;
}

export const DisabilityInsurancePolicyType = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="DisabilityInsurancePolicyType"
      render={({ field: { value, onChange } }) => {
        return (
          <Box role="radiogroup" aria-labelledby="disability-insurance-policy-type--label">
            <Label id="disability-insurance-policy-type--label" mb="4">
              Policy Type
            </Label>

            <Box display="flex">
              {data.Options.DisabilityInsurancePolicyTypeOptions.map(({ value: v, label }) => (
                <Radio
                  key={label}
                  name="DisabilityInsurancePolicyType"
                  checked={value === v}
                  onChange={() => onChange(v)}
                  mr="8"
                >
                  {label}
                </Radio>
              ))}
            </Box>
          </Box>
        );
      }}
    />
  );
};
